import { Pipe, PipeTransform } from '@angular/core';
import { formatNumbersInText } from '../utils/number-format';

@Pipe({
  name: 'formatNumbersText',
  standalone: true,
})
export class FormatNumbersTextPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null) {
      return '';
    }

    return formatNumbersInText(value);
  }
}
